import { createI18n } from 'vue-i18n';

import stringsEn from './strings-en';
import stringsDe from './strings-de';
import stringsFr from './strings-fr';
import stringsKo from './strings-ko';
import stringsSe from './strings-se';
import stringsUk from './strings-uk';
import stringsJp from './strings-jp';

const messages = {
    'en-US': stringsEn,
    'en-CA': stringsEn,
    'es-ES': stringsEn,

    'en-GB': stringsUk,
    'en-IE': stringsUk,
    'en-AU': stringsUk,
    'en-NZ': stringsUk,

    'fr-CA': stringsFr,
    'fr-FR': stringsFr,

    'de-DE': stringsDe,

    'ko-KR': stringsKo,

    'sv-SE': stringsSe,

    'ja-JP': stringsJp,
};

export default function mergeTranslations(locale, overrides) {
    const translations = JSON.parse(JSON.stringify(messages));

    if (overrides) {
        Object.keys(translations).forEach((lang) => {
            if (overrides[lang]) {
                Object.assign(translations[lang], overrides[lang]);
            }
        });
    }

    return createI18n({
        locale,
        fallbackLocale: 'en-US',
        messages: translations,
        silentTranslationWarn: true,
        silentFallbackWarn: true,
    });
}
